export var WorkspaceRole;
(function (WorkspaceRole) {
    WorkspaceRole["ADMIN"] = "admin";
    WorkspaceRole["USER"] = "user";
})(WorkspaceRole || (WorkspaceRole = {}));
//# sourceMappingURL=workspace-role.enum.js.map